'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dPolicy$002dPage$0024 from "./presto.-Edit-Policy-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459 from "./presto.-Presto-Router$$anon$59.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dCode$0024 from "./presto.types$-Policy-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$58() {
  this.bkB = null;
  this.bkt = null;
  this.bku = false;
  this.bkC = null;
  this.bkD = false;
  this.bkG = null;
  this.bkz = null;
  this.bkA = false;
  this.bkv = null;
  this.bkw = false;
  this.bkx = null;
  this.bky = false;
  this.bkE = false;
  this.bkF = false;
  this.bkB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkG = "EditPolicyPage";
}
export { $c_Lpresto_PrestoRouter$$anon$58 as $c_Lpresto_PrestoRouter$$anon$58 };
$p = $c_Lpresto_PrestoRouter$$anon$58.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$58;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$58() {
}
export { $h_Lpresto_PrestoRouter$$anon$58 as $h_Lpresto_PrestoRouter$$anon$58 };
$h_Lpresto_PrestoRouter$$anon$58.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bkB;
});
$p.L = (function() {
  if ((!this.bku)) {
    this.bkt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bku = true;
  }
  return this.bkt;
});
$p.O = (function() {
  if ((!this.bkD)) {
    this.bkC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkD = true;
  }
  return this.bkC;
});
$p.E = (function() {
  return this.bkG;
});
$p.t = (function() {
  if ((!this.bkA)) {
    this.bkz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkA = true;
  }
  return this.bkz;
});
$p.M = (function() {
  if ((!this.bkw)) {
    this.bkv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPolicy$002dCode$0024.$m_Lpresto_types$PolicyCode$().SK(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkw = true;
  }
  return this.bkv;
});
$p.Q = (function() {
  if ((!this.bky)) {
    this.bkx = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002459.$c_Lpresto_PrestoRouter$$anon$59();
    this.bky = true;
  }
  return this.bkx;
});
$p.w = (function() {
  if ((!this.bkF)) {
    this.bkE = false;
    this.bkF = true;
  }
  return this.bkE;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee437) => ((p) => \u03b4scrutinee437.cFY(p)))($j_presto$002e$002dEdit$002dPolicy$002dPage$0024.$m_Lpresto_EditPolicyPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$58 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$58, "presto.PrestoRouter$$anon$58", ({
  Op: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$58 as $d_Lpresto_PrestoRouter$$anon$58 };
//# sourceMappingURL=presto.-Presto-Router$$anon$58.js.map
